/*
 * Editorial scroll reveal ("rise"): sections fade + rise into view on scroll.
 * Progressive enhancement — if JS or IntersectionObserver is unavailable, or the
 * user prefers reduced motion, sections stay fully visible (no hiding class added).
 */
(function () {
  if (window.__editorialRevealInit) return;
  window.__editorialRevealInit = true;

  function init() {
    if (
      !('IntersectionObserver' in window) ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
    ) {
      return;
    }

    var els = document.querySelectorAll('.editorial-section');
    if (!els.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    var revealLine = window.innerHeight * 0.9;
    els.forEach(function (el) {
      el.classList.add('editorial-reveal');
      // Anything already in (or near) view is shown immediately to avoid a flash.
      if (el.getBoundingClientRect().top < revealLine) {
        el.classList.add('is-revealed');
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
